import { Color } from "~/core/models/Color.enum";
import { capitalizeFirstLetter } from "~/core/utils/string-tools";
import { DtwinLifeCycleState } from "~/modules/dtwin/models/DtwinLifeCycleState.enum";

export function getLifeCycleStateProperties(
  lifeCyleState: string,
  translate?: (key: string) => string,
  translateCheck?: (key: string) => boolean,
): {
  label?: string;
  hexadecimal: string;
  tailwindCSS: string;
} {
  if (lifeCyleState.startsWith("locked")) {
    lifeCyleState = DtwinLifeCycleState.LOCKED;
  }

  switch (lifeCyleState) {
    case DtwinLifeCycleState.REGISTERED:
    case DtwinLifeCycleState.ACTIVATED:
      return {
        label: translate
          ? translate(`dtwins.lifeCycleState.${lifeCyleState}`)
          : undefined,
        hexadecimal: "#027A48",
        tailwindCSS: `text-${Color.SUCCESS}-700`,
      };
    case DtwinLifeCycleState.DISABLED:
      return {
        label: translate
          ? translate(`dtwins.lifeCycleState.${lifeCyleState}`)
          : undefined,
        hexadecimal: "#B42318",
        tailwindCSS: `text-${Color.ERROR}-700`,
      };
    case DtwinLifeCycleState.LOCKED:
      return {
        label: translate
          ? translate(`dtwins.lifeCycleState.${lifeCyleState}`)
          : undefined,
        hexadecimal: "#F18006",
        tailwindCSS: `text-${Color.WARNING}-700`,
      };
    case DtwinLifeCycleState.PREPROVISIONED:
    default:
      return {
        label: translateCheck
          ? translateCheck(`dtwins.lifeCycleState.${lifeCyleState}`)
            ? translate
              ? translate(`dtwins.lifeCycleState.${lifeCyleState}`)
              : undefined
            : capitalizeFirstLetter(lifeCyleState)
          : undefined,
        hexadecimal: "#0E4981",
        tailwindCSS: `text-${Color.PRIMARY}-700`,
      };
  }
}
